import { formDataRequest, postRequest, getRequest } from '../libs/AxiosService.util';

export async function serviceCreateGiftStore(params) {
    return await formDataRequest('gifts/create', params);
}

export async function serviceUpdateGiftStore(params) {
    return await formDataRequest('gifts/update', params);
}

export async function serviceGetGiftStore(params) {
    return await postRequest("gifts", params);
}

export async function serviceGiftStoreDetail(params) {
    return await postRequest("gifts/detail", params);
}
export async function serviceDeleteGiftStore(params) {
    return await postRequest("gifts/delete", params);
}

export async function serviceGiftStoreIsExist (params) {  
    return await postRequest('gifts/check', params);
}

export async function serviceCouponsImportVerify (params) {
    return await formDataRequest('gifts/coupons/import/verify', params);
  }
  
export async function serviceCouponsImportFile(params) {
    return await formDataRequest('gifts/coupons/import', params);
  }
export async function serviceDownloadSampleCSv(params) {
    return await getRequest("gifts/coupons/import/sample", params);
}
export async function serviceGetCoupon(params) {
    return await postRequest("gifts/coupons", params);
}
export async function serviceGetProgramGift(params) {
    return await postRequest("programs/gifts", params);
}
export async function serviceProgramGiftAssociate(params) {
    return await postRequest("programs/gifts/associate", params);
}
